@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.menu {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 5px 0 map.get(core.$colors, accent);
  display: flex;
  flex-direction: column;
  padding: 15px 25px;
  position: absolute;
  right: 0px;
  top: calc(100% + 10px);
  width: max-content;
  z-index: 50;

  &Text {
    border-bottom: 1px solid map.get(core.$colors, iconHover);
    margin-bottom: 5px;
    padding-bottom: 5px;
  }
}
